import { LocationOn } from "@mui/icons-material";
import { Grid, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { properlizeWords } from "../../helpers";
import { IAuthState } from "../../stateManagement/reducers/authReducer";
import {
  ISite,
  ISitesState,
  tryFetchSites,
} from "../../stateManagement/reducers/sitesReducer";
import { IRootReducerT } from "../../stateManagement/reduxStore";
import IconText from "../IconText";
import { ISiteOwner } from "../RegisterSite/Form";

interface ISitesMenuProps {
  reAssigning?: boolean;
  setSite: (site: ISite) => void;
  owner: ISiteOwner;
}

const SitesMenu: React.FC<ISitesMenuProps> = ({
  reAssigning,
  setSite,
  owner,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const dispatch = useDispatch<any>();

  const { authToken } = useSelector<IRootReducerT, IAuthState>(
    (state) => state.auth,
  );
  const { fetchingSites, sites } = useSelector<IRootReducerT, ISitesState>(
    (state) => state.sites,
  );

  useEffect(() => {
    if (owner.id != "") {
      dispatch(
        tryFetchSites({
          authToken: authToken ?? "",
          ownerId: owner?.id,
          ownerType: owner.type,
        }),
      );
    }
  }, [owner.id]);

  return (
    <div>
      <Button
        id="sites-menu-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        color="primary"
        size="medium"
        onClick={handleClick}
      >
        {!reAssigning && `Select a Location`}
        {reAssigning && `Select Another Location`}
      </Button>
      <Menu
        id="sites-positioned-menu"
        aria-labelledby="sites-menu-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{ zIndex: 1400000000000000000, position: "absolute" }}
      >
        <Typography p={0.5} variant="body1" color="secondary">
          Select a Location
        </Typography>
        {sites.length > 0 &&
          sites.map((site, i) => {
            return (
              <MenuItem
                key={i}
                onClick={(e) => {
                  setSite(site);
                  handleClose();
                }}
              >
                <IconText
                  iconSrc={"/wxkjbxwx"}
                  topText={properlizeWords(site.name)}
                  variant="rounded"
                  svg={<LocationOn />}
                  bottomText={
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      maxWidth={"10rem"}
                      noWrap
                    >
                      {site.address}
                    </Typography>
                  }
                />
              </MenuItem>
            );
          })}
        {sites.length === 0 && fetchingSites && (
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <Grid item>
              <Typography
                variant="body2"
                color="secondary"
                p={1}
                sx={{ fontWeight: 400, textAlign: "center" }}
              >
                Loading...
              </Typography>
            </Grid>
          </Grid>
        )}
        {sites.length === 0 && !fetchingSites && (
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <Grid item>
              <Typography
                variant="body2"
                color="secondary"
                p={1}
                sx={{ fontWeight: 400, textAlign: "center" }}
              >
                Location coming soon.
              </Typography>
            </Grid>
          </Grid>
        )}
      </Menu>
    </div>
  );
};

export default SitesMenu;
